<template>
  <v-app class="pa-3">
    <v-app-bar
      class="px-5"
      app
      flat
    >
      <a
        href="http://abriron.com"
        target="_blank"
      >
        <v-img
          width="120"
          src="https://abriron.com/wp-content/uploads/2020/12/ironlogo.png"
        />
      </a>
      <v-spacer />
      <language v-model="lang" />
    </v-app-bar>
    <v-main>
      <v-container>
        <v-form ref="form">
          <v-card
            class="mx-auto justify-center mb-1 mt-3"
            max-width="500"
            :elevation="(isMobile ? 0 : 10)"
            :flat="isMobile"
          >
            <v-row :class="{'mx-0' : !isMobile}">
              <v-card-title
                class="justify-center mx-auto  my-4"
                grey
                darken-3
              >
                {{ $t('completeInformation') }}
              </v-card-title>
              <v-col
                class="py-0 mb-9"
                cols="12"
              >
                <v-text-field
                  v-model="shopId"
                  :label="$t('InstageramUsername')"
                  :rules="[v => !!v || $t('is-required')]"
                  dense
                  :placeholder="$t('username')"
                  outlined
                  clearable
                />
              </v-col>
              <p class="px-3 mb-0">
                {{ $t('copyLinkToInstagram') }}
              </p>
              <v-col
                cols="12"
              >
                <v-chip
                  label
                  dark
                  color="green"
                  v-clipboard:copy="baseUrl + '' + shopId"
                  @click="copied"
                  link
                >
                  {{ $t('shopLink') }} : {{baseUrl}}{{shopId}}
                  <v-icon class="mx-2">
                    mdi-content-copy
                  </v-icon>
                </v-chip>
              </v-col>
              <v-skeleton-loader
                v-if="!profile"
                class="mx-auto"
                width="100%"
                type="list-item-avatar-three-line"
              />
              <v-col
                v-if="profile"
                class="py-0 mt-0"
                cols="12"
              >
                <v-list
                  three-line
                  class="pa-0"
                >
                  <v-list-item>
                    <v-list-item-avatar
                      class="mt-7"
                      height="70"
                      width="70"
                    >
                      <v-img
                        aspect-ratio="1"
                        style="border: solid 1px #e3e3e3"
                        :src="(profile ? profile.avatar : '')"
                      />
                    </v-list-item-avatar>

                    <v-list-item-content class="mt-2 py-5">
                      <v-list-item-title>{{ (profile ? profile.fullName : '') }}</v-list-item-title>
                      <v-list-item-subtitle>{{ (profile ? profile.bio : '') }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ (profile ? profile.link : '') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col
                class="py-0 mt-6"
                cols="12"
              >
                <v-btn
                  :loading="loading"
                  block
                  color="deep-purple mb-3 accent-2 mr-0"
                  @click="checkAccount"
                >
                  {{ $t('reviewAccountInstagram') }}
                  <v-icon
                    right
                    dark
                  >
                    mdi-keyboard_return
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-container>
    </v-main>
    <v-footer
      class="py-2"
      style="font-size: 12px;position: fixed;background-color: #fff"
      app
    >
      <v-col
        class="text-center py-1"
        cols="12"
      >
        {{ new Date().getFullYear() }} — Abriron Cloud Panel V {{ env.version }}
      </v-col>
    </v-footer>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 10000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar != snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
  import General from '../../../../Mixins/general'
  import Language from '../../components/core/LanguageBar'
  export default {
    components: {
      Language,
    },
    mixins: [General],
    props: ['shopProp', 'planProp', 'phoneProp', 'phonePrefixProp'],
    data () {
      return {
        profile: null,
        shopId: null,
        baseUrl: 'https://shop.abriron.com/panel/',
        shopVerified: false,
        email: null,
        currency: null,
        phonePrefix: null,
        phone: null,
        plan: null,
        abrName: null,
        dateFormat: 'fa,en',
        dateFormatLang: 'YYYY/MM/DD',
        yearName: null,
        from: null,
        to: null,
        show: null,
        code: null,
        lang: null,
        firstname: null,
        lastname: null,
        username: null,
        password: null,
        has_error: false,
        text_error: null,
        loading: false,
      }
    },
    watch: {
      dateFormat () {
        this.from = null
        this.to = null
        if (this.dateFormat === 'fa,en') {
          this.dateFormatLang = 'jYYYY/jMM/jDD'
        }
        if (this.dateFormat === 'en,fa') {
          this.dateFormatLang = 'YYYY/MM/DD'
        }
      },
    },
    beforeMount () {
      if (!this.phoneProp) {
        this.$router.push({ path: '/register/index?in_=1' })
      }
      this.shopId = this.shopProp
      this.phonePrefix = this.phonePrefixProp
      this.phone = this.phoneProp
      this.plan = this.planProp
      if (this.dateFormat === 'fa,en') {
        this.dateFormatLang = 'jYYYY/jMM/jDD'
      }
      if (this.dateFormat === 'en,fa') {
        this.dateFormatLang = 'YYYY/MM/DD'
      }
    },
    mounted () {
      if (localStorage.getItem('lang')) {
        this.$refs.refLang.changeLanguage(JSON.parse(localStorage.getItem('lang')))
      }
    },
    methods: {
      copied () {
        this.snakbarText = this.$t('copied')
        this.snakbarColor = 'blue'
        this.snakbar = true
      },
      checkAccount () {
        if (!this.$refs.form.validate()) return false
        var app = this
        app.loading = true
        app.$axios.get(this.$apipoint + 'shop', {
          params: {
            checkAccount: app.shopId,
          },
        })
          .then(res => {
            res = res.data
            if (res && res.user) {
              app.profile = {
                pk: res.user.pk,
                username: res.user.username,
                fullName: res.user.full_name,
                bio: res.user.biography,
                link: res.user.external_url,
                avatar: res.avatar,
              }
              if (res.user.external_url === app.baseUrl + '' + app.shopId) {
                app.shopVerified = true
              }
              if (res.user.biography === app.baseUrl + '' + app.shopId) {
                app.shopVerified = true
              }
              if (app.shopVerified) {
                app.submit()
              }
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.loading = false))
      },
      submit () {
        var app = this
        app.loading = true
        app.$axios.post(this.$apipoint + 'shopsubmit', app.$data)
          .then(res => {
            app.$router.push({ name: 'registerFinish', params: { phone: '0' + this.phone, lang: this.lang, password: '0' + this.phone, shop: true } })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.loading = false))
      },
      editEmail () {
        this.goTo('register')
      },
      setDate: function () {
        var m = this.$moment()
        if (!this.date) {
          var today = ''
          if (this.dateFormat === 'fa,en') {
            this.dateFormatLang = 'jYYYY/jMM/jDD'
            today = m.format('jYYYY/jMM/jDD')
          }
          if (this.dateFormat === 'en,fa') {
            this.dateFormatLang = 'YYYY/MM/DD'
            today = m.format('YYYY/MM/DD')
          }
          if (today < this.$store.state.startDate) {
            today = this.$store.state.startDate
          }
          if (today > this.$store.state.endDate) {
            today = this.$store.state.endDate
          }
          this.date = today
          return today
        }
      },
    },

  }
</script>

<style scoped>

</style>
